import { getRuntimeConfig } from 'src/utils/runtimeConfig';

export const isProduction = () =>
  String(getRuntimeConfig().MODE ?? 'production') === 'production';

export const isDevelopment = () =>
  String(getRuntimeConfig().MODE ?? 'production') === 'development';

export const isQa = () =>
  String(getRuntimeConfig().MODE ?? '').toLowerCase() === 'qa';

export const isStaging = () =>
  String(getRuntimeConfig().MODE ?? '').toLowerCase() === 'stg';

export const isMockServices = () => {
  const config = getRuntimeConfig();
  return (
    config.VITE_MOCK_SERVICES === true || config.VITE_MOCK_SERVICES === 'true'
  );
};

export const sentryDsn = () => getRuntimeConfig().VITE_SENTRY_DSN;
export const sentryEnv = () => getRuntimeConfig().VITE_SENTRY_ENVIRONMENT;
export const sentryRelease = () => getRuntimeConfig().VITE_SENTRY_RELEASE;
